import React from 'react';
import {useField, useFormikContext} from 'formik';

import {Column} from '../layout';
import ErrorMessage from './ErrorMessage';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import './styles.scss';
import AppRadioSelectInput from '../input/app-radio-select-input';
import {Option} from '../input/app-radio-select-input/AppRadioSelectInput';
import {Store} from '../../store';

interface AppFormRadioFieldFieldProps
  extends React.HTMLProps<HTMLInputElement> {
  name: string;
  className: string;
  options: Option[];
  showErrorMessage?: boolean;
}

function AppFormRadioFieldField({
  options,
  name,
  className,
  showErrorMessage = false,
}: AppFormRadioFieldFieldProps) {
  const {setFieldTouched, touched, setFieldValue} = useFormikContext();
  const error = Store.getState().strings.value.pt.messages.requiredField;
  const visible = (touched as any)[name];

  const [field] = useField(name);

  return (
    <Column>
      {error && visible && showErrorMessage && (
        <div className="app-form-field-error-content error-radio">
          <Icon
            changeViewbox
            viewBox={'0 0 24 24'}
            width="24"
            height="24"
            name={Icons.ALERT_PROBLEM}
            color={colors.alertRed}
          />
          <ErrorMessage error={error} visible={visible} />
        </div>
      )}
      <AppRadioSelectInput
        value={field.value}
        options={options}
        onChange={(value) => setFieldValue(name, value)}
        onBlur={() => setFieldTouched(name)}
        className={className}
      />
    </Column>
  );
}

export default AppFormRadioFieldField;
